export const promoNameRequiredMsg = 'Promo offer name is required (128 chars max)';
export const promoNameInvalidMsg = 'Invalid promo offer name';

export const categoryKeyRequiredMsg = 'Category key is required';
